import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerErrorComponent } from '../components/server-error/server-error.component';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => { return event }, (error: HttpErrorResponse) => {

      if (error.status == 500) {
        console.log("----response----");
        console.error("status code:");
        console.error(error.status);
        console.error(error.message);
        console.error(error.error);
        console.log("--- end of response---");
        setTimeout(() => {
          
          this.snackBar.openFromComponent(ServerErrorComponent, {
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: "app-snack-bar",
          })

        }, 10)



      }
      
      // http response status code
      return error


    }));
  }
}
